export default "__VITE_ASSET__CoYC9zY$__"